import { render, staticRenderFns } from "./MessageEditor.vue?vue&type=template&id=05f0eb60&"
import script from "./MessageEditor.vue?vue&type=script&lang=js&"
export * from "./MessageEditor.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditor.vue?vue&type=style&index=0&id=05f0eb60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports